import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { connect } from 'react-redux';
import { IRootState } from '../../../@types/redux';
import appFunctionsService from '../../../services/appFunctionsService';
import { createSelector } from 'reselect';
import lodash from 'lodash';
import { IBoreholeTest } from '../../../@types/model/borehole/boreholeTest';

interface IBoreholeWaterLevelGraphProps {
    boreholeTests : Array<IBoreholeTest>;
    isLoading : boolean;
}

interface IBoreholeWaterLevelGraphState {
}

class BoreholeWaterLevelGraph extends React.Component<IBoreholeWaterLevelGraphProps, IBoreholeWaterLevelGraphState> {
    constructor(props : IBoreholeWaterLevelGraphProps) {
        super(props);
        this.state = {};
    }

    public readonly getBoreholeTests = (state : IBoreholeWaterLevelGraphState, props : IBoreholeWaterLevelGraphProps) => props.boreholeTests;
    public readonly getMax = createSelector(
        [this.getBoreholeTests],
        (boreholeTests) => {
            const max = lodash.maxBy(boreholeTests, n => n.WaterLevel);

            return max?.WaterLevel ? (max.WaterLevel + 5) : 0;
        },
    );

    public readonly getData = createSelector(
        [this.getBoreholeTests],
        (boreholeTests) => {
            return boreholeTests
                .filter(n => typeof n.Yield !== 'undefined')
                .map((n) => ({
                    name: appFunctionsService.formatDateTimeToDateOnly(n.CreatedOn),
                    value: n.WaterLevel ? n.WaterLevel : 0,
                }));
        },
    );
    
    public readonly getPoints = createSelector(
        [this.getBoreholeTests],
        (boreholeTests) => {
            return boreholeTests
                .filter(n => typeof n.WaterLevel !== 'undefined')
                .map((n) => ({
                    value: n.WaterLevel ?? 0,
                    x: n.WaterLevel ?? 0,
                    y: n.WaterLevel ?? 0,
                }));
        },
    );

    public readonly render = () => {
        const { isLoading, boreholeTests } = this.props;
        const max = this.getMax(this.state, this.props);

        const data = this.getData(this.state, this.props);
        const points = this.getPoints(this.state, this.props);
        return (
            <div className='wfill'>
                {
                    isLoading &&
                    <LinearProgress />
                }
                {
                    !isLoading && boreholeTests.length === 0 &&
                    <div className='fdr flx1 jcc aic'>
                        <Typography>
                            None
                        </Typography>
                    </div>
                }
                {
                    !isLoading && boreholeTests.length > 0 &&
                    <ResponsiveContainer width={'99%'} aspect={3}>
                        <LineChart data={data}>
                            <XAxis dataKey='name' reversed/>
                            <YAxis domain={[0, max]} reversed />
                            <CartesianGrid />
                            <Tooltip allowEscapeViewBox={{
                                x: false,
                                y: false,
                            }} />
                            <Line points={points} type='monotone' dataKey='value' stroke='#2294FC' />
                        </LineChart>
                    </ResponsiveContainer>
                }
            </div>
        );
    };
}

const mapStateToProps = (state : IRootState) => {
    return {
        boreholeTests: state.borehole.boreholeTests,
        isLoading: state.borehole.loadingTests,
    };
};

export default connect(
    mapStateToProps,
)(BoreholeWaterLevelGraph);
